<div class="container" style="border:1px solid #bebaba">
  <div class="row text-center background-bottom">
    <div class="col-md-12 text-center img-fluid" style="margin-top:4%; margin-bottom:4%; padding-right:4%; padding-left:4%">
      <p class="text-center" style="font-size:1.2em; color:white">
        This official website is maintained by the Settlement Administrator under the supervision of Co-Lead Counsel for the members of the
        Settlement Class in <i>In re Turkey Antitrust Litigation, No. 1:19-cv-08318</i>  (the “Settlement”), which is pending in the United
        States District Court for the Northern District of Illinois, Eastern Division.
      </p>
    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12" style="text-align:justify; text-justify:distribute-all-lines; font-weight:bold">
      The information on this website is only a summary of the terms of the Settlement. For more detailed information, please review the <a href="~/docs/Certified/Turkey - CooperFarbest-Long Form Notice- Final.pdf" target="_blank">Long Form Notice</a>
      and/or the Settlement Agreements found on the <a [routerLink]="['/court-docs']">Court Documents</a>
      page of this website.<br /><br />

      If you are a Settlement Class Member, your legal rights will be affected by this Settlement whether you act or do not act.<br /><br />

      <b>
        If you purchased fresh or frozen, uncooked turkey breast, ground turkey, or whole bird turkey products (the “Class Products”) from Defendants
        in the United States during the Class Period.” This class of direct purchasers is called the “Certified Class.” The Class Period is January 1,
        2010, through December 31, 2016, this class action may affect your rights.
      </b><br /><br />

      <ul>
        <li>
          There is an update in In re Turkey Antitrust Litigation, No. 1:19-cv-08318, pending in the United States District Court for the Northern District of Illinois, the lawsuit in which you previously received notices. The purpose of the new notice is to inform you of your rights related to (i) the Court formally certifying the class action lawsuit on January 22, 2025, and (ii) two new settlements (the “Settlements”) that have been reached on behalf of Direct Purchaser Plaintiffs with Defendants Cooper Farms, Inc. (“Cooper Farms”) and Farbest Foods, Inc. (“Farbest Foods”) (together, “Settling Defendants”).
        </li>
        <br />
        <li>
          On January 22, 2025, the Court issued an order certifying a class of direct purchasers defined as: “[a]ll persons and entities who directly purchased fresh or frozen, uncooked turkey breast, ground turkey, or whole bird turkey products (the “Class Products”) from Defendants in the United States during the Class Period.” This class of direct purchasers is called the “Certified Class.” The Class Period is January 1, 2010, through December 31, 2016.
        </li>
        <br />
        <li>
          The Settlements require the Settling Defendants to pay $1,687,500 each. In addition to these monetary payments, the Settling Defendants have agreed to provide specific cooperation in the Direct Purchaser Plaintiffs’ continued prosecution of this action.
        </li>
        <br />
        <li>
          The Settlement requires Cargill to pay $32,500,000. In addition to this monetary payment, Cargill has agreed to respond to specific requests made by the Direct Purchaser Plaintiffs in their continued prosecution of the litigation.
        </li>
        <br />
        <li>
          The Court has not decided whether the Settling Defendants did anything wrong, and the Settling Defendants deny any wrongdoing.
        </li>
        <br />
        <li>
          Your legal rights are affected whether you act or don’t act. Please read carefully.
        </li>
      </ul>
    </div>
  </div>
  <div class="panel-heading" style="background-color: #27451c; color: white; text-align:center">
    <h2><b>Important Dates</b></h2><br />
  </div>
  <div class="panel-heading" style="background-color: black; color: white; text-align:center; font-weight:bold">
    <div class="row">
      <div class="col-md-4">
        Exclusion Deadline<br />
        May 22, 2025
      </div>
      <div class="col-md-4">
        Objection Deadline<br />
        May 22, 2025
      </div>
      <div class="col-md-4">
        Court Hearing Date<br />
        July 10, 2025
      </div>
    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%; margin-top:3%">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="3" style="background-color: #0e3870; color: #ffffff; font-weight: bold; font-size: 2.0em; text-align: center;">
                YOUR LEGAL RIGHTS AND OPTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                ASK TO BE EXCLUDED FROM THE CERTIFIED CLASS AND SETTLEMENTS
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                You must submit a valid request for exclusion to remove yourself from the Certified Class. Your legal rights are explained in
                Question 19 of the Notice. Requests for Exclusion must be postmarked or received by <b>May 22, 2025</b>.
              </td>

            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                OBJECT TO THE SETTLEMENTS
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                Write to the Court about why you do not like the Settlements. Objections must be postmarked or received by <b>May 22, 2025</b>.
              </td>

            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                ATTEND THE
                FAIRNESS HEARING

              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                Ask to speak in Court about the fairness of the Settlements.
              </td>
            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                DO NOTHING
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                If you do nothing, you will remain a member of the Certified Class and may participate in the Settlements and in any monetary distribution
                to qualified purchasers if there are other settlements or judgments. The Settlements will resolve your claims against Cooper Farms and
                Farbest Foods, and you will give up your rights to sue or to continue to sue Cooper Farms or Farbest Foods about the Released Claims
                (as defined in the Settlement Agreements). You will be bound by any future judgments or settlements with the non-settling Defendants.
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>

  <br />
  <br />
  <div class="row" style="margin-left: 5%; margin-right: 5%; text-align: justify; text-justify: distribute-all-lines">
    <div class="col-md-12 ">
      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Class Definition—You May Be Part of the Class </span><br /><br />
      The Court decided that, the Certified Class is defined as:<br /><br />

      “All persons and entities who directly purchased fresh or frozen, uncooked turkey breast, ground turkey, or whole bird turkey products
      (“Class Products”) from Defendants in the United States from January 1, 2010, through December 31, 2016 (“Class Period”).”<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Settlement Benefits</span><br /><br />

      If the Settlements are approved, Cooper Farms and Farbest Foods will each pay $1,687,500 to resolve the claims against them. The specific
      claims being released, called the “Released Claims,” are defined in the Settlement Agreements. In addition, Cooper Farms and Farbest Foods
      have also agreed to respond to specific requests for cooperation made by the Direct Purchaser Plaintiffs in their continued prosecution of
      the litigation.<br /><br />


      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">How to Get a Payment</span><br /><br />

      The proceeds from these Settlements will not be distributed to qualifying Certified Class Members at this time. Instead, Co-Lead Class Counsel
      intend to combine the Settlements’ proceeds with proceeds from future settlements or other recoveries in the litigation before distribution.
      You will receive notice of any such future settlements or recoveries and when it is time to file a valid claim.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Settlement Hearing</span><br /><br />

      The Court will hold a hearing to decide whether to approve the Settlements (the “Fairness Hearing”). You may attend and you may ask to speak,
      but you don’t have to. The Court will hold the Fairness Hearing on July 10, 2025, at 10:00 a.m. Central  at the United States District Court
      for the Northern District of Illinois, Courtroom 1925, Everett McKinley Dirksen U.S. Courthouse, 219 S. Dearborn Street, Chicago, IL 60604. At
      this hearing, the Court will consider whether the Settlements are fair, reasonable, and adequate. If there are objections, the Court will
      consider them. The Court will listen to people who have asked to speak at the hearing. After the hearing, the Court will decide whether to
      approve the Settlements. We do not know how long these decisions will take.<br /><br />

      The Court may hold the Fairness Hearing remotely via telephone or video conference and may change call-in details or move the Fairness
      Hearing to a later date without providing additional notice to members of the Certified Class. Updates will be posted to this Settlement Website.
      <br /><br />


      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Further Information</span><br /><br />

      This website and the <a href="~/docs/Certified/Turkey - CooperFarbest-Long Form Notice- Final.pdf" target="_blank">Notice</a> summarize the Settlement.
      For more details regarding this Settlement, please reference the Settlement Agreement or other documents filed in the case under the
      “<a id="turkey" asp-area="" asp-controller="Home" asp-action="CourtDocs">Court Documents</a>” link above. You may also contact the
      Settlement Administrator for further information regarding this Settlement.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Settlement Administrator</span><br /><br />


      <div class="row">
        <div class="col-md-12 text-center">
          Turkey Antitrust Litigation<br />
          c/o A.B. Data, Ltd.<br />
          P.O. Box 173015<br />
          Milwaukee, WI  53217<br />
          877-777-9637<br />
          E-mail:  <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a><br />
        </div>
      </div>
      <br /><br />
      If you have questions, you may call the Turkey Antitrust Litigation Helpline at 877-777-9637 or email <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a>.
    </div>
  </div>
  <br />
  <br />
  <br />
  <br />
  <div class="row">
    <div class="col-md-12">
      <a>
        <img src="../../../assets/people graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>

    </div>
  </div>
</div>


